import { isFeatureFlagEnabled } from "./check";
import { useFeatureFlagsConfig } from "./provider";

// use within react components, and for pure js functions use isFeatureFlagEnabled
export function useFeatureFlag(path: string): boolean {
  const config = useFeatureFlagsConfig();

  return isFeatureFlagEnabled(config, path);
}
